import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ShowIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0014 6C15.8577 6 18.5208 8.65975 20.1138 10.5144C20.8218 11.3387 20.8218 12.6613 20.1138 13.4856C18.5208 15.3402 15.8577 18 12.0014 18C8.14519 18 5.48214 15.3402 3.88905 13.4856C3.18111 12.6613 3.18111 11.3387 3.88905 10.5144C5.48214 8.65975 8.14519 6 12.0014 6ZM15.5179 12C15.5179 13.9882 13.9431 15.6 12.0004 15.6C10.0578 15.6 8.48293 13.9882 8.48293 12C8.48293 10.0118 10.0578 8.40002 12.0004 8.40002C13.9431 8.40002 15.5179 10.0118 15.5179 12ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      />
    </Icon>
  );
};
